<template lang="html">
  <div>
    <v-app-bar app flat color="white" height="72">
      <v-container class="px-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="d-flex align-center">
              <v-btn icon width="40" height="40" class="mr-2" @click="backToMenu()">
                <v-icon>
                  mdi-arrow-left
                </v-icon>
              </v-btn>
              <div class="title-page-text">
                {{ $t('v2.loyalty_points') }}
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-container class="pt-0">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
          <div class="mt-2">
            <div class="point-detail-customer br-10">
              <div class="point-col-detail-customer">
                <div class="flex-image">
                  <div class="mr-2 align-self-center d-flex">
                    <img src="@/assets/images/v2/img/icon_point.png" alt="Voucher" class="image-24">
                  </div>
                  <div class="flex-image-content">
                    <div class="flex-image-content-text ol-grey-content font-11">
                      {{ $t('v2.total_point') }}
                    </div>
                    <div class="flex-image-content-text font-14 font-weight-600">
                      {{ Number(customer.join_loyalty_points) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4">
            <template v-if="points.length > 0">
              <div v-for="(item, i) in points" :key="i">
                <div class="title-date-point">
                  {{ item.fearned_date }}
                </div>
                <div v-scroll="onScrollItem" class="list-loyaltypoint">
                  <template v-for="(point, x) in item.items">
                    <div :key="x" :class="['flex-image pa-4 list-item-loyaltypoint', { 'cursor-pointer': point.order_id }]" @click="point.order_id && goToOrder(point.order_id)">
                      <div class="mr-2 align-self-center d-flex">
                        <img v-if="!$isEmpty(point.logo)" :src="point.logo.base" alt="Voucher" class="image-40 br-8">
                        <img v-else src="@/assets/images/v2/img/icon_transaction.png" alt="Voucher" class="image-40 br-8">
                      </div>
                      <div class="flex-image-content">
                        <div class="flex-image-content-text ol-black font-14 font-weight-600">
                          {{ point.store_name }}
                        </div>
                        <div v-mask-money="point.total_amount" class="flex-image-content-text font-12 font-weight-400 ol-grey-content" />
                      </div>
                      <div class="ml-2">
                        <div class="ol-accent font-14 font-weight-600">
                          + <span v-mask-money-only="point.earned_points" /> pts
                        </div>
                      </div>
                    </div>
                    <div v-if="x !== (item.items.length - 1)" :key="x + '-line'" class="div-line" />
                  </template>
                </div>
              </div>
            </template>
            <div v-else class="text-center mt-4">
              <div class="mb-2">
                <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="6" y="30" width="78" height="36" rx="6" fill="#767676" />
                  <rect y="24" width="90" height="38" rx="6" fill="#CECECE" />
                  <rect x="7" y="30" width="34" height="7" rx="3.5" fill="#767676" />
                  <rect x="7" y="42" width="34" height="2" rx="1" fill="#767676" />
                  <path d="M58 30H78C81.3137 30 84 32.6863 84 36V50C84 53.3137 81.3137 56 78 56H58V30Z" fill="#767676" />
                </svg>
              </div>
              <div class="font-18 font-weight-700">
                {{ $t('v2.no_point_transactions_available') }}
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { debounce } from 'debounce'
import {
  getData as getCustomer,
  getDataPoint as getDataLoyaltyPoint
} from '@/api/customer'
export default {
  data() {
    return {
      points: [],
      customer: {},
      settingScroll: {
        point: false
      },
      params: {
        page: 1,
        per_page: 10,
        sort_column: 'earned_date',
        sort_type: 'desc'
      }
    }
  },
  computed: {
    dataParams() {
      var params = {
        page: this.params.page,
        per_page: this.params.per_page,
        sort_column: this.params.sort_column,
        sort_type: this.params.sort_type
      }
      return params
    },
    loadedPointsDates() {
      const ids = []
      if (this.points.length > 0) {
        this.points.map(item => {
          ids.push(item.fearned_date)
        })
        return ids
      }
      return ids
    }
  },
  mounted() {
    this.getDataCustomer()
    this.getPoint()
  },
  methods: {
    async getDataCustomer() {
      try {
        const { data } = await getCustomer()
        this.customer = data.data
      } catch (e) {
        this.customer = {}
      }
    },
    async getPoint() {
      try {
        const { data } = await getDataLoyaltyPoint(this.dataParams)
        this.settingScroll.point = (data.data.length < this.params.per_page)
        const data_point = data.data
        await data_point.map(item => {
          if (!this.loadedPointsDates.includes(item.fearned_date)) {
            this.points.push({
              fearned_date: item.fearned_date,
              items: data_point.filter(__data => __data.fearned_date === item.fearned_date)
            })
          } else {
            const points = this.points.filter(data_item => {
              return item.fearned_date === data_item.fearned_date
            })
            const index = points[0].items.findIndex((e) => e.id === item.id)
            if (index === -1) {
              points[0].items.push(...data_point.filter(__data => __data.fearned_date === item.fearned_date))
            }
          }
        })
        this.params.page++
      } catch (e) {
        this.settingScroll.point = true
      }
    },
    backToMenu() {
      this.$router.push({ name: '_menu' }).catch(() => {})
    },
    goToOrder(id) {
      this.$router.push({ name: '_transaction', params: { id: id }}).catch(() => {})
    },
    onScrollItem() {
      this.scrollLoadPoint()
    },
    scrollLoadPoint: debounce(async function() {
      if (this.settingScroll.point === false) {
        if ((window.innerHeight + window.scrollY + 100) >= document.body.offsetHeight) {
          this.getPoint()
        }
      }
    }, 500)
  }
}
</script>
